import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0c3d960f&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0c3d960f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3d960f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/data/.jenkins/workspace/yyWebsite/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c3d960f')) {
      api.createRecord('0c3d960f', component.options)
    } else {
      api.reload('0c3d960f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0c3d960f&scoped=true&", function () {
      api.rerender('0c3d960f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/interHospital/index.vue"
export default component.exports